import { jsxs as _jsxs } from "react/jsx-runtime";
import { formatFullName } from "@air/utilities";
export const ContentCollectionAccountInformation = (param)=>{
    let { account } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "hidden text-14 text-grey-10 md:block",
        "data-testid": "CONTENT_COLLECTION_ACCOUNT_INFORMATION",
        children: [
            formatFullName(account.firstName, account.lastName),
            " (",
            account.email,
            ")"
        ]
    });
};
